import Css from "./style.module.scss";

import { YEARS_PER_PAGE } from "nlib/ui/DatePicker/constants";
import DatePickerContainer from "nlib/ui/DatePicker/lib/DatePickerContainer";
import DatePickerContext from "nlib/ui/DatePicker/lib/DatePickerContext";
import DatePickerHeader from "nlib/ui/DatePicker/lib/DatePickerHeader";
import DatePickerYear from "nlib/ui/DatePicker/lib/DatePickerYear";
import React, { useCallback, useContext, useMemo } from "react";

const DatePickerYears = ({ monthOnly }) => {
  const { currentYear, setCurrentYear, setCurrentMonth, setMonthsView } = useContext(DatePickerContext);

  const startYear = currentYear - (currentYear % YEARS_PER_PAGE);

  const years = useMemo(() => {
    const result = [];

    // eslint-disable-next-line no-loops/no-loops
    for (let iterator = 0; iterator < YEARS_PER_PAGE; iterator++) {
      const current = startYear + iterator;

      result.push({
        year: current,
        selected: current === currentYear
      });
    }

    return result;
  }, [startYear, currentYear]);

  const onPrevClick = useCallback(() => {
    setCurrentYear((prev) => prev - YEARS_PER_PAGE);
    setCurrentMonth(null);
  }, [setCurrentYear, setCurrentMonth]);

  const onNextClick = useCallback(() => {
    setCurrentYear((prev) => prev + YEARS_PER_PAGE);
    setCurrentMonth(null);
  }, [setCurrentYear, setCurrentMonth]);

  const onSelect = useCallback((year) => {
    setCurrentYear(year);
    setCurrentMonth(null);
    setMonthsView();
  }, [setCurrentMonth, setCurrentYear, setMonthsView]);

  return (
    <DatePickerContainer monthOnly={monthOnly} className={Css.datePickerYears}>
      <DatePickerHeader
        label={`${startYear} - ${startYear + YEARS_PER_PAGE - 1}`}
        onPrevClick={onPrevClick}
        onNextClick={onNextClick} />
      <div className={Css.years}>
        {years.map(({ year, selected }) => (
          <DatePickerYear
            key={year}
            year={year}
            monthOnly={monthOnly}
            selected={selected}
            onSelect={onSelect} />
        ))}
      </div>
    </DatePickerContainer>
  );
};

export default React.memo(DatePickerYears);
